import * as server from '../entries/pages/sverdle/_page.server.js';

export const index = 4;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/sverdle/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/sverdle/+page.server.js";
export const imports = ["_app/immutable/nodes/4.CL3q1xdA.js","_app/immutable/chunks/DsnmJJEf.js","_app/immutable/chunks/D3MuNBmD.js","_app/immutable/chunks/B5U7fqmF.js","_app/immutable/chunks/D3xBo6kT.js","_app/immutable/chunks/CgpIHpM6.js","_app/immutable/chunks/DVS0YAe2.js","_app/immutable/chunks/C9sQAHSZ.js","_app/immutable/chunks/C7YJlRmi.js","_app/immutable/chunks/BuPXQUT0.js","_app/immutable/chunks/BzfD0-ZS.js","_app/immutable/chunks/CXZTR9LB.js","_app/immutable/chunks/DLExxFlQ.js"];
export const stylesheets = ["_app/immutable/assets/4.Ccxm5Kmf.css"];
export const fonts = [];
